var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkipBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14C13.4124 14.0006 13.3262 13.9782 13.25 13.935L3.75 8.43503C3.67305 8.39143 3.60905 8.32819 3.56452 8.25177C3.51999 8.17535 3.49653 8.08848 3.49653 8.00003C3.49653 7.91159 3.51999 7.82472 3.56452 7.7483C3.60905 7.67188 3.67305 7.60864 3.75 7.56503L13.25 2.06503C13.326 2.02115 13.4122 1.99805 13.5 1.99805C13.5878 1.99805 13.674 2.02115 13.75 2.06503C13.8263 2.10909 13.8896 2.17252 13.9335 2.24891C13.9774 2.3253 14.0003 2.41193 14 2.50003V13.5C14 13.6326 13.9473 13.7598 13.8536 13.8536C13.7598 13.9474 13.6326 14 13.5 14ZM5 8.00003L13 12.635V3.36503L5 8.00003ZM1 2.00003H2V14H1V2.00003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipBack);
export default __webpack_public_path__ + "static/media/skip-back.8b53a16f7ae93b02e9ee7aa74e9b6327.svg";
export { ForwardRef as ReactComponent };